import LogoBTC from 'assets/icons/BTC.svg';
import LogoBNB from 'assets/icons/BNBwhite.svg';
import LogoDOGE from 'assets/icons/DOGE.svg';
import { ABI, CONTRACTS, CHAIN_DETAILS, USE_MAINNET } from 'const';
import { GetHTTPWeb3ProviderForChain } from 'utils/MetamaskSuite';


export const WEB3_HTTP_INSTANCES_BY_CHAIN = {
  'bsc': GetHTTPWeb3ProviderForChain('bsc'),             // short name
  'BNB Smart Chain': GetHTTPWeb3ProviderForChain('bsc'), // wagmi-reported name
  //'dogechain': GetHTTPWeb3ProviderForChain('dogechain'),
}

export const REFERRAL_CONTRACTS_BY_CHAIN = {
  'bsc': GetReferralsContractForChain('bsc'),
}

export const GAME_DETAILS_BY_CHAIN = {
  'bsc': {
    'bnb': GetGameDetails_BSC_BNB(),
    'btc': GetGameDetails_BSC_BTC()
  }
}


// imported elsewhere to provide type hints for IDEs, in addition to being a placeholder
export const DUMMY_GAME_DETAILS = {
  priceDecimals: 0,
  tickerSymbol: '',
  chainName: '',
  gameName: '',
  logo: '', // prediction asset logo(BTC, DOGE, etc.)
  web3http: null,
  wantedChain: {
    id: 0,
    rpc: null,
    explorer: '',
    tickerSymbol: '',
    logo: '', // chain native currency logo(BNB, MATIC, wDOGE, TRX, etc.)
    name: '',
    nameFancy: ''
  },
  contracts: {
    prediction: null,
    referrals: null
  },
}


export function GetGameDetailsFromCurrentURL(gameNameOverride) {
  const splitPathname = window.location.pathname.split('/');
  const chainName = splitPathname[2];
  let gameName = splitPathname[3];
  if (gameNameOverride)
    gameName = gameNameOverride;
  const failedToParseURL = (!chainName || !gameName);
  const chainNameNotKnown = (!Object.keys(CONTRACTS).includes(chainName));
  let gameNameNotKnown = false;
  if (!chainNameNotKnown)
    gameNameNotKnown = (!Object.keys(CONTRACTS[chainName])?.includes(gameName));

  if (failedToParseURL || chainNameNotKnown || gameNameNotKnown) {
    //console.log('Failed to parse game\'s URL; returning empty gameDetails');
    return DUMMY_GAME_DETAILS;
  } else {
    return GAME_DETAILS_BY_CHAIN[chainName][gameName];
  }
}

export function GetPredictionContractAddr(gameDetails) {
  if (!gameDetails)
    throw new SyntaxError('missing one or more required arguments: gameDetails');

  if (USE_MAINNET)
    return CONTRACTS[gameDetails.chainName][gameDetails.gameName].mainnet;
  else
    return CONTRACTS[gameDetails.chainName][gameDetails.gameName].testnet;
}


export function GetWeb3HTTPInstanceForChain(chainName) {
  if (!chainName) throw new SyntaxError('Missing required argument: chainName');
  return WEB3_HTTP_INSTANCES_BY_CHAIN[chainName];
}

function GetGameDetails_BSC_BNB() {
  const variables = {
    chainName: 'bsc',
    gameName: 'bnb',
    priceDecimals: 2,
    tickerSymbol: 'BNB',
    logo: LogoBNB,
  }
  return ComposeGameDetailsForGiven(variables);
};

function GetGameDetails_BSC_BTC() {
  const variables = {
    chainName: 'bsc',
    gameName: 'btc',
    priceDecimals: 2,
    tickerSymbol: 'BTC',
    logo: LogoBTC,
  }
  return ComposeGameDetailsForGiven(variables);
};


function ComposeGameDetailsForGiven(parameters) {
  if (!parameters) throw new SyntaxError('missing required argument: parameters');
  const predictionContract = GetPredictionContractForGivenParameters(parameters);
  const details = {
    wantedChain: GetFormattedWantedChainFrom(CHAIN_DETAILS[parameters.chainName]),
    priceDecimals: parameters.priceDecimals,
    tickerSymbol: parameters.tickerSymbol,
    chainName: parameters.chainName, // this is a lower-case name of the chain, not its numeric ID
    gameName: parameters.gameName,
    logo: parameters.logo,
    web3http: WEB3_HTTP_INSTANCES_BY_CHAIN[parameters.chainName],
    contracts: {
      prediction: predictionContract,
      referrals: REFERRAL_CONTRACTS_BY_CHAIN[parameters.chainName]
    },
  }
  return details;
}


function GetPredictionContractForGivenParameters(parameters) {
  if (!parameters) throw new SyntaxError('Missing required argument: parameters')
  let predictionAddress;
  const web3http = WEB3_HTTP_INSTANCES_BY_CHAIN[parameters.chainName];
  if (USE_MAINNET)
    predictionAddress = CONTRACTS[parameters.chainName][parameters.gameName].mainnet;
  else
    predictionAddress = CONTRACTS[parameters.chainName][parameters.gameName].testnet;

  return new web3http.eth.Contract(ABI.prediction, predictionAddress);
}

function GetReferralsContractForChain(chainName) {
  if (!chainName) throw new SyntaxError('Missing required argument: chainName')
  const web3http = WEB3_HTTP_INSTANCES_BY_CHAIN[chainName];
  if (USE_MAINNET)
    return new web3http.eth.Contract(ABI.referrals, CONTRACTS[chainName].referrals.mainnet);
  else
    return new web3http.eth.Contract(ABI.referrals, CONTRACTS[chainName].referrals.testnet);
}

function GetFormattedWantedChainFrom(chainDetails) {
  if (!chainDetails) throw new SyntaxError('missing required argument: chainDetails');
  let subnetDetails;
  if (USE_MAINNET)
    subnetDetails = chainDetails.mainnet;
  else
    subnetDetails = chainDetails.testnet;
  const formatedChainDetails = {
    ...subnetDetails,
    tickerSymbol: chainDetails.tickerSymbol,
    logo: chainDetails.logo,
    name: chainDetails.name,
    nameFancy: chainDetails.nameFancy
  };
  return formatedChainDetails;
}
